export { default } from "./fetalSexInResults";
